import { create } from "zustand";

interface VehicleState {
  statuses: string[];
  lockStatuses: string[];
  brands: string[];
  bikeTypes: string[];

  bikeStatusByIdSuccess: boolean | null;

  brokenBikeStatuses: string[];

  setStatuses: (statuses: string[]) => void;
  setLockStatuses: (lockStatuses: string[]) => void;
  setBrands: (brands: string[]) => void;
  setBikeTypes: (types: string[]) => void;
  setBikeStatusByIdSuccess: (success: boolean | null) => void;
  setBrokenBikeStatuses: (statuses: string[]) => void;
  clearVehicle: () => void;
}

export const useVehicleStore = create<VehicleState>()((set) => ({
  statuses: [],
  lockStatuses: [],
  brands: [],
  bikeTypes: [],
  bikeStatusByIdSuccess: null,
  brokenBikeStatuses: [],

  setStatuses: (statuses) => set({ statuses }),

  setLockStatuses: (lockStatuses) => set({ lockStatuses }),

  setBrands: (brands) => set({ brands }),

  setBikeTypes: (types) => set({ bikeTypes: types }),

  setBikeStatusByIdSuccess: (success) =>
    set({ bikeStatusByIdSuccess: success }),

  setBrokenBikeStatuses: (statuses) => set({ brokenBikeStatuses: statuses }),

  clearVehicle: () =>
    set({
      statuses: [],
      lockStatuses: [],
      brands: [],
      bikeTypes: [],
      bikeStatusByIdSuccess: null,
      brokenBikeStatuses: [],
    }),
}));

export const useVehicleStatuses = () =>
  useVehicleStore((state) => state.statuses);
export const useLockStatuses = () =>
  useVehicleStore((state) => state.lockStatuses);
export const useVehicleBrands = () => useVehicleStore((state) => state.brands);
export const useBikeTypes = () => useVehicleStore((state) => state.bikeTypes);
export const useBikeStatusByIdSuccess = () =>
  useVehicleStore((state) => state.bikeStatusByIdSuccess);
export const useBrokenBikeStatuses = () =>
  useVehicleStore((state) => state.brokenBikeStatuses);
